export const ROLES_GET = 'ROLES_GET';
export const ROLE_ADD = 'ROLE_ADD';
export const ROLE_EDIT = 'ROLE_EDIT';
export const ROLE_DELETE = 'ROLE_DELETE';
